import { CheckModalComponent } from './check-modal/check-modal.component';
import { Component, OnInit, Input } from '@angular/core';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { WarehouseService } from '../../services/warehouse/warehouse.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../services/storage.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.scss']
})
export class WarehouseComponent implements OnInit {
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  @Input() entradasMercanciaSeleccionadas;
  @Input() inputChecked;
  @Input() btnCrear;
  arrASN : any[];
  arrASNPo : any[];
  selectedASN : any;
  selectedPos : any; 
  selected = [];
  idASN;
  busy: boolean = false;
  modalRespuesta;
  closeResult = '';
  titulo; mensaje;
  verDetalle = false;
  checkPosicion;
  btnHabilitar = false;
  flagDatos = false;
  busyEM = false;

  entradaMercanciaCreada;
  errorAprobarAsn;
  constructor(
    private translate: TranslateService,
    private warehouseService: WarehouseService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private storageService: StorageService
  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
      this.messages.emptyMessage = text;
    });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
      this.messages.totalMessage = text;
    });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
      this.messages.selectedMessage = text;
    });

    this.translate.get('texto.entradaMercanciaCreada').subscribe(
      text => {
      this.entradaMercanciaCreada = text;
    });

    this.translate.get('texto.errorAprobarAsn').subscribe(
      text => {
      this.errorAprobarAsn = text;
    });
  }

  ngOnInit() {
    //this.loadDummyData();
    this.loadASN();
  }


   // event handlers
   private selectASN(event, asn: any) {
    this.verDetalle = true;
    this.idASN = asn.id;
    this.selectedASN = asn;
    // this.arrASNPo = [...this.arrASNPo];
    this.loadASNPosition(asn.id);
  }


   // get data from server
   private loadASN() {
    this.busy = true;
    this.arrASNPo = [];
    const estatus = 'EnAprobacion';
    const tipo = 'Producto';
    this.warehouseService.getASN(estatus, tipo).subscribe(
      data => {
        this.verDetalle = false;
        this.busy = false;
        this.populateTable(data.avisoDeEmbarque);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        }
      },
    );

  }

  private populateTable(data) {
    if (data.length > 0) {
      this.arrASN = data;
    }

    if (data.length === 0) {
      this.flagDatos = true;
    } else {
      this.flagDatos = false;
    }
  }

  private loadASNPosition(iasn: any) {
    this.busyEM = true;
    const asn = iasn;

    this.warehouseService.getASNPositions(asn).subscribe(
      data => {
        this.busyEM = false;
        this.verDetalle = true;
        this.arrASNPo = [...data.posicion_oc];
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } 
      },
    );

  }

  onSelect({ selected }, i) {
    // console.log(this.selected);
  }

  open(content) {
        const identificador: any = this.selected[0].posicionOc.num_posicion;
        const modalRef = this.modalService.open(CheckModalComponent, { centered: true, keyboard: false, backdrop: 'static'});
        modalRef.componentInstance.id = this.idASN;
        modalRef.componentInstance.select = this.selected;
        modalRef.componentInstance.inputChecked = (<HTMLInputElement>document.getElementById('pos' + identificador));
        modalRef.componentInstance.btnCrear = this.btnHabilitar;
        modalRef.result.then((result) => {
          let ch;
          let pos;
          if (result === 'terminar') {
            for (let i = 0; i < this.arrASNPo.length; i++) {
              pos = this.arrASNPo[i].posicionOc.num_posicion;
              ch = (<HTMLInputElement>document.getElementById('pos' + pos)).checked;
              if (ch === true) {
                this.btnHabilitar = true;
                break;
              } else {
                this.btnHabilitar = false;
              }
            }
          } else {
            modalRef.close();
            for (let i = 0; i < this.arrASNPo.length; i++) {
              pos = this.arrASNPo[i].posicionOc.num_posicion;
              ch = (<HTMLInputElement>document.getElementById('pos' + pos)).checked;
              if (ch === true) {
                this.btnHabilitar = true;
                break;
              } else {
                this.btnHabilitar = false;
              }
            }
          }
        }).catch((error) => {
          // console.log(error);
        });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  revisarStatus() {
    // console.log(this.arrASNPo.length);
    // console.log(this.arrASN.length);
  }

  crearEM(mensajeRes) {
    const ordenCompra = this.selected[0].posicionOc.ordencompra_id;
    this.warehouseService.crearEM(ordenCompra, this.idASN).subscribe(
      data => {
        const respuesta = data.result;
        if (respuesta.status === 'S') {
          this.arrASN = [];
          this.arrASNPo = [];
          this.titulo = this.entradaMercanciaCreada;
          this.loadASN();
          this.btnHabilitar = false;
          this.verDetalle = false;
        } else {
          this.titulo = this.errorAprobarAsn;
        }
        this.mensaje = respuesta.message;
        this.openMensajeRespuesta(mensajeRes);

      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } 
      },
      );
  }

  openMensajeRespuesta(mensajeRes) {
    this.modalRespuesta = this.modalService.open(mensajeRes, {centered: true, keyboard: false, backdrop: 'static'});
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason2(reason)}`;
    });
  }

  private getDismissReason2(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/warehouse/warehouse.component.ts